import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../universities";
import { Adapter } from "../../../../shared/adapter";
import { UniversitiesAdapter } from "../../../../adapter/universities-adapter";

export const FETCH_DATA_UNIVERSITIES_REQUEST =
  "FETCH_DATA_UNIVERSITIES_REQUEST";
export const FETCH_DATA_UNIVERSITIES_SUCCESS =
  "FETCH_DATA_UNIVERSITIES_SUCCESS";
export const FETCH_DATA_UNIVERSITIES_FAILURE =
  "FETCH_DATA_UNIVERSITIES_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataSearchersRequest = () => {
  return {
    type: FETCH_DATA_UNIVERSITIES_REQUEST,
  };
};

const fetchDataSearchersSuccess = (
  data: any
): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_UNIVERSITIES_SUCCESS,
    payload: data,
  };
};

const fetchDataSearchersFailure = (error: any) => {
  return {
    type: FETCH_DATA_UNIVERSITIES_FAILURE,
    payload: error,
  };
};

export const find = (page: number, pageSize: number, query: Query) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataSearchersRequest());
    try {
      const response = await Find("universities", query, page, pageSize);
      dispatch(
        fetchDataSearchersSuccess({
          meta: response.meta,
          values: Adapter.from(response.data).to((value) =>
            new UniversitiesAdapter(value).adapt()
          ),
        })
      );
    } catch (error: any) {
      dispatch(fetchDataSearchersFailure(error.message));
    }
  };
};
